import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

export interface OrdersTabExtraContextValue {
  tabExtra: ReactNode;
  setTabExtra: (node: ReactNode) => void;
}

export const OrdersTabExtraContext = createContext<OrdersTabExtraContextValue>({
  tabExtra: null,
  setTabExtra: () => {},
});

export function OrdersTabExtraProvider({ children }: { children: ReactNode }) {
  const [tabExtra, setTabExtra] = useState<ReactNode>(null);

  return (
    <OrdersTabExtraContext.Provider value={{ tabExtra, setTabExtra }}>
      {children}
    </OrdersTabExtraContext.Provider>
  );
}

type TabExtraContent = ReactNode | (() => ReactNode);

/** Register toolbar content shown to the right of order route tabs. */
export function useOrdersTabExtraContent(content: TabExtraContent, deps: unknown[]) {
  const { setTabExtra } = useContext(OrdersTabExtraContext);

  useEffect(() => {
    setTabExtra(typeof content === 'function' ? content() : content);
    return () => setTabExtra(null);
  }, deps);
}
